import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AddOpportunityService } from '@app/features/customers/add-opportunity/service/add-opportunity.service';
import { FolderService } from "@app/shared/common-folder-structure/service/folder.service";
var SmsModalComponent = /** @class */ (function () {
    function SmsModalComponent(fb, opportunityService, confirmationBoxHelper, ajsScope, folderService) {
        this.fb = fb;
        this.opportunityService = opportunityService;
        this.confirmationBoxHelper = confirmationBoxHelper;
        this.ajsScope = ajsScope;
        this.folderService = folderService;
        this.smsTemplateSearchList = {};
        this.saveDisabled = false;
        this.templateData = {};
        this.smsInputTextLength = 0;
        this.showSmsModal = false;
        this.scheduled = true;
        this.scheduleActivity = true;
        this.loadFirstTemplate = false;
        this.replaceTagParams = {};
        this.onSave = new EventEmitter();
        this.onClose = new EventEmitter();
        this.smsScreenLabel = 'sms.templates';
        this.smsForm = this.fb.group({
            "contactTelephoneId": ["", Validators.required],
            "activityType": [""],
            "message": ["", Validators.required],
            "customerId": [""]
        });
    }
    SmsModalComponent.prototype.ngOnInit = function () {
        this.getSmsTemplates();
        this.getContacts();
    };
    SmsModalComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.showSmsModal) {
            if (this.showSmsModal) {
                this.smsInputTextLength = 0;
                if (this.loadFirstTemplate && this.smsTemplateSearchList.length && this.smsForm) {
                    this.templateData = this.smsTemplateSearchList[0];
                }
                // time delay to initialise tinymce and listen for keyup
                setTimeout(function () {
                    _this.updateTinyMCEValues();
                }, 400);
            }
            else {
                this.clearForm();
            }
        }
    };
    SmsModalComponent.prototype.getSmsTemplates = function () {
        var _this = this;
        this.opportunityService.listSmsTemplates(this.customerId, null, this.invoiceId).subscribe(function (data) {
            _this.smsTemplateList = data;
            _this.smsTemplateSearchList = data;
        });
    };
    SmsModalComponent.prototype.getContacts = function () {
        var _this = this;
        if (this.invoiceId) {
            this.opportunityService.getCustomerSmsAddress(this.customerId, 'Y').subscribe(function (data) {
                if (Object.values(data).length) {
                    _this.customerSmsDetails = data;
                }
            });
        }
        else {
            this.opportunityService.getSmsContacts(this.customerId).subscribe(function (data) {
                var contactData = data['contacts'];
                _this.smsTemplateList = _this.smsTemplateSearchList = data['smsTemplate'];
                if (Object.values(contactData).length) {
                    _this.customerSmsDetails = Object.values(contactData);
                }
            });
        }
    };
    SmsModalComponent.prototype.searchSmsTemplates = function (event) {
        var _this = this;
        var templateValues = [];
        this.smsTemplateSearchList.filter(function (value) {
            if (value["templateName"].toLowerCase().includes(event.target.value.toLowerCase())) {
                templateValues.push(value);
                _this.smsTemplateList = templateValues;
            }
        });
    };
    SmsModalComponent.prototype.isScheduledActivity = function (event) {
        this.scheduled = event.target.checked;
    };
    SmsModalComponent.prototype.showTemplateOptions = function () {
        $("#smsTemplateId").val('');
        this.smsTemplateList = this.smsTemplateSearchList;
        $(".sms-template-wrapper").addClass("sms-template-open");
    };
    SmsModalComponent.prototype.closeModal = function () {
        var _this = this;
        this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the sms?', this.ajsScope)
            .then(function () {
            _this.closeModalWithoutConfirmation();
        }).catch(function () { });
    };
    SmsModalComponent.prototype.clearForm = function () {
        this.smsForm.patchValue({
            message: '',
            contactTelephoneId: '',
        });
        tinymce.remove('#sms-template-message');
    };
    SmsModalComponent.prototype.closeModalWithoutConfirmation = function () {
        this.clearForm();
        this.showSmsModal = false;
        this.onClose.emit();
    };
    SmsModalComponent.prototype.selectedsmsTemplate = function (smsData) {
        var _this = this;
        this.replaceTagParams.message = smsData.message;
        if (this.screenType == 'jobInvoice') {
            this.replaceTagParams.screenType = 'invoice';
            this.replaceTagParams.tablePKId = this.invoiceId;
            this.replaceTagParams.smsUrlType = 'short';
        }
        else if (this.screenType == 'jobs') {
            this.replaceTagParams.screenType = 'jobs';
            this.replaceTagParams.tablePKId = this.tablePKID;
            this.replaceTagParams.smsUrlType = 'short';
        }
        this.folderService.getReplacedMessage(this.replaceTagParams).subscribe(function (data) {
            if (data) {
                _this.templateData = data;
                _this.updateTinyMCEValues();
                $(".sms-template-wrapper").removeClass("sms-template-open");
            }
        });
    };
    SmsModalComponent.prototype.updateTinyMCEValues = function () {
        var _this = this;
        tinymce.init({
            selector: "#sms-template-message",
            menubar: false,
            toolbar: false,
            plugins: "paste",
            paste_as_text: true,
            browser_spellcheck: true,
            paste_block_drop: false,
            content_css: window.location.origin + '/css/public/stylesheets/mce-editor.css',
            setup: function (editor) {
                editor.on('LoadContent', function () {
                    if (_this.templateData.hasOwnProperty('message')) {
                        editor.setContent(_this.templateData.message);
                        _this.onEditorChange();
                    }
                });
                editor.on('keyup', function () {
                    _this.onEditorChange();
                });
            }
        });
    };
    SmsModalComponent.prototype.onEditorChange = function () {
        var editor = tinymce.get('sms-template-message'); // Get the editor instance
        var txtMessage = editor.getContent({ format: "text" });
        this.smsInputTextLength = txtMessage.length;
        this.smsForm.patchValue({
            message: txtMessage,
        });
        this.smsForm.updateValueAndValidity();
    };
    SmsModalComponent.prototype.sendSms = function () {
        if (this.smsForm.valid) {
            this.saveDisabled = true;
            this.smsForm.controls['activityType'].setValue("SMS");
            this.smsForm.controls['customerId'].setValue(this.customerId);
            var smsData = this.smsForm.value;
            smsData.isScheduled = this.scheduled;
            this.onSave.emit(smsData);
            this.saveDisabled = false;
        }
    };
    SmsModalComponent.prototype.cancelTemplate = function () {
        $(".sms-template-wrapper").removeClass("sms-template-open");
    };
    return SmsModalComponent;
}());
export { SmsModalComponent };
